/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductSalesfor1997Module
 * Purpose		: Module for ProductSalesfor1997.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { ProductSalesfor1997Service } from './ProductSalesfor1997.service';
import { ProductSalesfor1997ListComponent } from './ProductSalesfor1997List.component';
import { ProductSalesfor1997SearchComponent } from './ProductSalesfor1997Search.component';
import { ProductSalesfor1997DetailsComponent } from './ProductSalesfor1997Details.component';

import { ProductSalesfor1997RoutingModule } from './ProductSalesfor1997-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    ProductSalesfor1997RoutingModule
  ],
  declarations: [
    ProductSalesfor1997ListComponent,
	ProductSalesfor1997SearchComponent,
	ProductSalesfor1997DetailsComponent
  ],
  providers: [
    ProductSalesfor1997Service
  ]
})

export class ProductSalesfor1997Module { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductSalesfor1997/ProductSalesfor1997.module.ts